import { useQuery } from "@tanstack/react-query";
import { GlobalSearchCardsResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { useAuthentication } from "../auth/useAuthentication.ts";
import { queryKeys } from "./queryKeys.ts";

export const useGlobalSearchCards = (searchTerm: string | null) => {
  const { getToken } = useAuthentication();
  return useQuery({
    queryKey: queryKeys.globalSearchCards(searchTerm),
    queryFn: async ({ signal }): Promise<GlobalSearchCardsResponse> => {
      const token = await getToken();
      const response = await fetch(
        `/api/cards/global/search?searchTerm=${encodeURIComponent(searchTerm ?? "")}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal,
        },
      );

      if (!response.ok) {
        throw new Error("Server returned status outside the 200 range.");
      }
      return (await response.json()) as GlobalSearchCardsResponse;
    },
    enabled: !!searchTerm,
  });
};
